import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);
// import { truncateText } from "../utils";

export default function Message({ message, isYou }) {
  const countyCode = message.country && message.country !== "undefined" ? message.country.toLowerCase() : "";

  return (
    <div className="card" style={{ borderRadius: "15px" }}>
      <div className="card-bodyx">
        <div className="d-flex flex-row justify-content-between">
          <div
            className="p-3 ml-2"
            style={{ borderRadius: "15px", width: "100%", backgroundColor: "rgba(57, 192, 237,.2)" }}
          >
            <div className="d-flex flex-row">
              <span>{message.username} </span>
              {message.is_authenticated && <div color="#1d9bf0" style={{ display: "inline", marginRight: "5px" }} />}
              {countyCode && (
                <div className="ml-1">
                  from {message.country}{" "}
                  <img
                    style={{ display: "inline-block", marginTop: "-4px" }}
                    src={`/flags/${countyCode}.png`}
                    alt={message.country}
                  />
                </div>
              )}
            </div>
            <p style={{ color: "black" }} dangerouslySetInnerHTML={{ __html: message.text }}></p>
            <div style={{ color: "gray" }} className="d-flex flex-row small justify-content-end">
              {dayjs(message.timestamp).fromNow()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
